import gql from 'graphql-tag';
import { condominiumProfileFeaturesFragment } from '../fragments';

export const dwellerAccessDataProfiles = gql`
  query dwellerAccessDataProfiles(
    $applicationKey: String!
    $condominiumContextId: ID
  ) {
    dwellerAccessDataProfiles(
      applicationKey: $applicationKey
      condominiumContextId: $condominiumContextId
    ) {
      value
      label
    }
  }
`;

export const dwellerAccessDataProfileFeatures = gql`
  query dwellerAccessDataProfileFeatures(
    $profileId: Int!
    $applicationKey: String!
  ) {
    dwellerAccessDataProfileFeatures(
      profileId: $profileId
      applicationKey: $applicationKey
    ) {
      applicationFeatureId
      profilePermissionId
      name
      fieldName
      ableToRead
      ableToWrite
      allowsEdit
    }
  }
`;

export const getDwellerAccessDataCondominiumProfileFeatures = gql`
  query dwellerAccessDataCondominiumProfileFeatures(
    $profileId: ID!
    $applicationKey: String!
    $condominiumContextId: ID!
  ) {
    dwellerAccessDataCondominiumProfileFeatures(
      profileId: $profileId
      applicationKey: $applicationKey
      condominiumContextId: $condominiumContextId
    ) {
      ...condominiumProfileFeaturesParts
    }
  }
  ${condominiumProfileFeaturesFragment}
`;

export const resendEmail = gql`
  query resendEmail($email: String!) {
    resendEmail(email: $email)
  }
`;
